'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.PushCartItem = PushCartItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _themeImages = require('@shopify/theme-images');

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _functional = require('../../../utils/functional');

var _i18n = require('../../../services/i18n');

var _constants = require('../../constants');

var _products = require('../../../services/products');

var _product = require('../../../utils/product');

var _tracking = require('../../../utils/tracking');

var _utils = require('./utils');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartItem(_ref) {
  var _this = this;

  var lineItem = _ref.lineItem,
      sendRandomID = _ref.sendRandomID;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(lineItem.quantity),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      quantity = _useState4[0],
      setQuantity = _useState4[1];

  var dispatch = (0, _reactRedux.useDispatch)();

  var productMeasure = (0, _utils.getProductMeasure)(lineItem);
  var isMixMatchChild = (0, _utils.isLineItemMixMatchChild)(lineItem);
  var isMixMatchChildFirst = (0, _utils.isLineItemMixMatchChildFirst)(lineItem);
  var isHiddenLineItem = isMixMatchChild && !isMixMatchChildFirst;
  var productTitle = isMixMatchChildFirst ? lineItem.properties[_constants.MIX_AND_MATCH_TITLE_PROPERTY_KEY] : lineItem.title;
  var productUrl = isMixMatchChildFirst ? lineItem.properties[_constants.MIX_AND_MATCH_URL_PROPERTY_KEY] : lineItem.url;
  var productImage = isMixMatchChildFirst ? lineItem.properties[_constants.MIX_AND_MATCH_IMAGE_PROPERTY_KEY] : lineItem.image;

  var className = ['psh-Item', isMixMatchChild && 'psh-Item-mixMatchChild', loading && 'psh-Item-loading'].filter(Boolean).join(' ');

  var handleQuantityChange = (0, _react.useCallback)(function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(value) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);

              if (!(value > 0)) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return dispatch(pushCartActions.updateLineItem({
                lineItem: lineItem,
                quantity: value
              }));

            case 4:
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return dispatch(pushCartActions.removeLineItem({ lineItem: lineItem }));

            case 8:

              setLoading(false);

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [quantity, setLoading]);

  var handleGA4Tracking = (0, _react.useCallback)(function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref4) {
      var eventName = _ref4.eventName,
          quantity = _ref4.quantity;

      var _ref5, compare_at_price, eventGA4;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _products.getProductByHandleCustomJSON)(lineItem.handle);

            case 3:
              _ref5 = _context2.sent;
              compare_at_price = _ref5.compare_at_price;
              eventGA4 = new Event(eventName);

              eventGA4.payload = (0, _tracking.setDataLayerItem)({
                product: {
                  title: lineItem.title,
                  vendor: lineItem.vendor,
                  product_type: lineItem.product_type
                },
                variant: {
                  title: lineItem.variant_title,
                  // eslint-disable-next-line camelcase
                  compare_at_price: String(compare_at_price / 100),
                  price: String(lineItem.final_price / 100),
                  sku: lineItem.sku
                },
                quantity: quantity
              });
              // eventGA4.payload.context = {
              //   category: 'Mini-Cart',
              // }
              document.dispatchEvent(eventGA4);
              _context2.next = 12;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[0, 10]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [lineItem]);

  var handleRemove = function () {
    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoading(true);

              _context3.next = 3;
              return dispatch(pushCartActions.removeLineItem({ lineItem: lineItem }));

            case 3:
              handleGA4Tracking({ eventName: 'remove_from_cart', quantity: lineItem.quantity });

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function handleRemove() {
      return _ref6.apply(this, arguments);
    };
  }();

  var plusQuantity = (0, _react.useCallback)((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
    var newQuantity;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            newQuantity = quantity + 1;
            _context4.next = 3;
            return handleQuantityChange(newQuantity);

          case 3:

            handleGA4Tracking({ eventName: 'add_to_cart', quantity: 1 });

            setQuantity(newQuantity);

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  })), [quantity, setQuantity]);

  var minusQuantity = (0, _react.useCallback)((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
    var newQuantity;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(quantity <= 0)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt('return');

          case 2:
            newQuantity = quantity - 1;
            _context5.next = 5;
            return handleQuantityChange(newQuantity);

          case 5:

            handleGA4Tracking({ eventName: 'remove_from_cart', quantity: 1 });

            setQuantity(newQuantity);

          case 7:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  })), [quantity, setQuantity]);

  (0, _react.useEffect)(function () {
    setQuantity(lineItem.quantity);
  }, [lineItem]);

  (0, _react.useEffect)(function () {
    /*
    This is to make sure loading is set to false if the lineItem is removed but a new lineItem takes its place
     One example of this is if you have 5 of the same product in the cart and 1 is discounted down to zero. If you remove the discounted product one of the full price products could take it's place. We don't want an infinite loading state if that is the case
    */

    setLoading(false);
  }, [lineItem]);

  return _react2.default.createElement(_react2.default.Fragment, null, !isHiddenLineItem && _react2.default.createElement('li', { className: 'psh-Body_Item' }, _react2.default.createElement('div', { className: className }, _react2.default.createElement(MaybeAnchor, { className: 'psh-Item_ImageContainer', href: productUrl }, _react2.default.createElement('img', {
    className: 'psh-Item_Image',
    src: (0, _themeImages.getSizedImageUrl)(productImage, '220x220'),
    alt: productTitle
  })), _react2.default.createElement('div', { className: 'psh-Item_Content' }, _react2.default.createElement('h5', { className: 'psh-Item_Title' }, _react2.default.createElement(MaybeAnchor, { className: 'psh-Item_TitleLink', href: productUrl }, productTitle), !isMixMatchChildFirst && productMeasure && _react2.default.createElement('span', { className: 'psh-Item_Measure' }, productMeasure)), !isMixMatchChildFirst && _react2.default.createElement('div', { className: 'psh-Item_Price' }, _react2.default.createElement('p', null, (0, _functional.formatMoney)(lineItem.final_line_price)), lineItem.unit_price_measurement && _react2.default.createElement('p', { className: 'hdn-Sm clr-Grey_700 util-Tt-lc' }, (0, _product.formatProductPriceMeasurements)(lineItem.price, lineItem.unit_price_measurement, false))), isMixMatchChildFirst && _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement('p', {
    className: 'psh-Item_Price',
    dangerouslySetInnerHTML: {
      __html: (0, _functional.formatMoney)(lineItem.properties[_constants.MIX_AND_MATCH_SHELL_PRICE_PROPERTY_KEY])
    }
  }), _react2.default.createElement('p', { className: 'psh-Item_Text' }, lineItem.properties[_constants.MIX_AND_MATCH_CHILD_PRODUCTS_PROPERTY_KEY].reduce(function (all, cur, index) {
    return [].concat((0, _toConsumableArray3.default)(all), [_react2.default.createElement('br', { key: index }), cur]);
  }))), _react2.default.createElement('div', { className: 'psh-Item_Controls' }, _react2.default.createElement('div', { className: 'psh-Item_Actions' }, !isMixMatchChildFirst && _react2.default.createElement('div', { className: 'qty-Adjuster' }, _react2.default.createElement('div', { className: 'qty-Adjuster_Group' }, _react2.default.createElement('button', {
    className: 'qty-Adjuster_Control qty-Adjuster_Control-minus',
    onClick: minusQuantity
  }, _react2.default.createElement('span', { className: 'qty-Adjuster_IndicatorLine qty-Adjuster_IndicatorLine-line1' })), _react2.default.createElement('input', {
    className: 'qty-Adjuster_Input',
    value: quantity,
    type: 'text',
    readOnly: true
  }), _react2.default.createElement('button', {
    className: 'qty-Adjuster_Control qty-Adjuster_Control-plus',
    onClick: plusQuantity
  }, _react2.default.createElement('span', { className: 'qty-Adjuster_IndicatorLine qty-Adjuster_IndicatorLine-line1' }), _react2.default.createElement('span', { className: 'qty-Adjuster_IndicatorLine qty-Adjuster_IndicatorLine-line2' })))), !isMixMatchChildFirst && _react2.default.createElement('button', { type: 'button', className: 'psh-Item_Remove', onClick: handleRemove }, (0, _i18n.t)('cart.drawer.remove')), isMixMatchChildFirst && _react2.default.createElement('button', {
    type: 'button',
    className: 'psh-Item_Remove',
    onClick: function onClick() {
      return sendRandomID(lineItem.properties[_constants.MIX_AND_MATCH_ID_PROPERTY_KEY]);
    }
  }, (0, _i18n.t)('cart.drawer.remove'))))), _react2.default.createElement('div', { className: 'psh-Item_Loading' }, _react2.default.createElement('svg', { viewBox: '0 0 120 30', xmlns: 'http://www.w3.org/2000/svg', fill: '#000' }, _react2.default.createElement('circle', { cx: '15', cy: '15', r: '15' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    from: '15',
    to: '15',
    begin: '0s',
    dur: '0.8s',
    values: '15;9;15',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'fill-opacity',
    from: '1',
    to: '1',
    begin: '0s',
    dur: '0.8s',
    values: '1;.5;1',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  })), _react2.default.createElement('circle', { cx: '60', cy: '15', r: '9', fillOpacity: '.3' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    from: '9',
    to: '9',
    begin: '0s',
    dur: '0.8s',
    values: '9;15;9',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'fill-opacity',
    from: '.5',
    to: '.5',
    begin: '0s',
    dur: '0.8s',
    values: '.5;1;.5',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  })), _react2.default.createElement('circle', { cx: '105', cy: '15', r: '15' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    from: '15',
    to: '15',
    begin: '0s',
    dur: '0.8s',
    values: '15;9;15',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'fill-opacity',
    from: '1',
    to: '1',
    begin: '0s',
    dur: '0.8s',
    values: '1;.5;1',
    calcMode: 'linear',
    repeatCount: 'indefinite'
  })))))));
}

PushCartItem.propTypes = {
  lineItem: _propTypes2.default.object.isRequired,
  sendRandomID: _propTypes2.default.func
};

function MaybeAnchor() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref9$isAnchor = _ref9.isAnchor,
      isAnchor = _ref9$isAnchor === undefined ? true : _ref9$isAnchor,
      children = _ref9.children,
      props = (0, _objectWithoutProperties3.default)(_ref9, ['isAnchor', 'children']);

  if (isAnchor === false && 'href' in props) {
    delete props['href'];
  }

  return isAnchor ? _react2.default.createElement('a', props, children) : _react2.default.createElement('div', props, children);
}

MaybeAnchor.propTypes = {
  isAnchor: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};